export default "__VITE_ASSET__Bz3Lh1oR__"